export const GET_Cosmetics_LOADING = "Cosmetics/get/laoding";
export const GET_Cosmetics_SUCCESS = "Cosmetics/get/success";
export const GET_Cosmetics_ERROR = "Cosmetics/get/error";

// add item  
export const ADD_Cosmetics_LOADING = "Cosmetics/add/laoding";
export const ADD_CosmeticsT_SUCCESS = "Cosmetics/add/success";
export const ADD_Cosmetics_ERROR = "Cosmetics/add/error";

// update  
export const UPDATE_Cosmetics_LOADING = "Cosmetics/update/laoding";
export const UPDATE_Cosmetics_SUCCESS = "Cosmetics/update/success";
export const UPDATE_Cosmetics_ERROR = "Cosmetics/update/error";


// REMOVE  
export const REMOVE_Cosmetics_LOADING = "Cosmetics/remove/laoding";
export const REMOVE_Cosmetics_SUCCESS = "Cosmetics/remove/success";
export const REMOVE_Cosmetics_ERROR = "Cosmetics/remove/error";
export const SORT_COSMETICS="COSMETIC/sort"
